import React from 'react';
import ArchiveIcon from '@mui/icons-material/Archive';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { Box } from '@mui/material';

import { TooltipIconButton } from '@paragon/client-tools';
import { ProjectLayoutModel } from '@paragon/contract-library';

import { showArchiveConfirmationDialog, showProjectFilesDialog } from '../store/actions/dialogActions';
import { duplicateProject } from '../store/actions/projects';
import { useAppDispatch } from './hooks';
import { useCreateEstimateDisabledReason } from './ProjectEstimatesTab';
import { DesignProjectButton } from './Tools/DesignProjectButton';
import { ProjectRootActionsMenu } from './Tools/ProjectRootActionsMenu';

interface Props {
  readonly projectGuid: string;
  readonly project: ProjectLayoutModel | undefined;
  readonly onCreateEstimate: () => void;
}

export function ProjectDrawerActions({ projectGuid, project, onCreateEstimate }: Props) {
  const dispatch = useAppDispatch();
  const createEstimateDisabledReason = useCreateEstimateDisabledReason(project);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      <TooltipIconButton
        title={createEstimateDisabledReason ?? 'Create Estimate'}
        size="small"
        disabled={createEstimateDisabledReason != null}
        onClick={onCreateEstimate}
      >
        <RequestQuoteIcon fontSize="small" />
      </TooltipIconButton>
      <TooltipIconButton
        title="Project Files"
        size="small"
        onClick={() => dispatch(showProjectFilesDialog(projectGuid))}
      >
        <AttachFileIcon fontSize="small" />
      </TooltipIconButton>
      <TooltipIconButton title="Copy Project" size="small" onClick={() => dispatch(duplicateProject(projectGuid))}>
        <ContentCopyIcon fontSize="small" />
      </TooltipIconButton>
      <TooltipIconButton
        title="Archive Project"
        size="small"
        onClick={() => dispatch(showArchiveConfirmationDialog([projectGuid]))}
      >
        <ArchiveIcon fontSize="small" />
      </TooltipIconButton>
      <ProjectRootActionsMenu projectGuid={projectGuid} />

      <Box sx={{ marginLeft: 'auto' }}>
        <DesignProjectButton projectGuid={projectGuid} size="small" />
      </Box>
    </Box>
  );
}
